import { Box, styled } from '@mui/material';

const GapStyled = styled(Box)({
    gap: '16px',
});

export interface InputRowContainerProps {
    children: React.ReactNode;
}

const InputRowContainer = (props: InputRowContainerProps): JSX.Element => {

    return (
        <GapStyled
            display="flex"
            alignItems="center"
            flexWrap="nowrap"
            marginBottom="10px"
        >
        {props.children}
        </GapStyled>
    );
  };

export default InputRowContainer;